import { MouseEvent } from "react";
import BaseButton from "components/common/BaseButton";
import CircleCloseFilterSvg from "components/svg/CircleCloseFilter";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import "./TableCellOverlay.scss";

interface TableCellOverlayProps {
  entityId: string;
  showModal: boolean;
  onClose: () => void;
  entityType: string;
  onDelete: (entityId: string) => void;
}

const TableCellOverlay = ({
  entityId,
  showModal,
  onClose,
  entityType,
  onDelete,
}: TableCellOverlayProps) => {
  const intl = useIntl();
  const history = useHistory();

  if (!showModal) return null;

  const handleView = (e: MouseEvent) => {
    e.stopPropagation();
    history.push(`/us-admin-app/${entityType}/${entityId}/view`);
  }

  const handleEdit = (e: MouseEvent) => {
    e.stopPropagation();
    history.push(`/us-admin-app/${entityType}/${entityId}/edit`);
  };

  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation();
    onDelete(entityId);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="table__body-overlay-element-container"
    >
      <BaseButton
        text={intl.formatMessage({
          id: "tableCellOverlay.view",
        })}
        handleSubmit={handleView}
        className="usadmin-table__buttons-overlay__button"
      />
      <BaseButton
        text={intl.formatMessage({
          id: "tableCellOverlay.edit",
        })}
        handleSubmit={handleEdit}
        className="usadmin-table__buttons-overlay__button"
      />
      <BaseButton
        text={intl.formatMessage({
          id: "tableCellOverlay.delete",
        })}
        backgroundColor="red"
        handleSubmit={handleDelete}
        className="usadmin-table__buttons-overlay__button"
      />
      <BaseButton
        className="table__body-overlay-element-close usadmin-table__buttons-overlay__button"
        iconComponent={<CircleCloseFilterSvg />}
        handleSubmit={(e: React.MouseEvent) => {
          e.stopPropagation();
          onClose();
        }}
      />
    </div>
  );
};

export default TableCellOverlay;
